import dynamic from "next/dynamic";
import SlimFooterConfig from "./slim-footer-config";
import SlimFooterAdvancedConfig from "./slim-footer-advanced-config";
const SlimFooterComponent = dynamic(()=>import("./slim-footer-component"));
export default {
    SlimFooterComponent,
    SlimFooterConfig,
    SlimFooterAdvancedConfig
};
